export enum ReportModelActionType {
  AddReportModel = 'AddReportModel',
  RemoveReportModel = 'RemoveReportModel',
}
